// Flickity.createMethods.push('_createPrevNextCells');

// Flickity.prototype._createPrevNextCells = function() {
// 	this.on('select', this.setPrevNextCells);
// };

// Flickity.prototype.setPrevNextCells = function() {
// 	// remove classes
// 	changeSlideClasses(this.previousSlide, 'remove', 'is-prev');
// 	changeSlideClasses(this.nextSlide, 'remove', 'is-next');
// 	// set slides
// 	this.previousSlide = this.slides[(this.selectedIndex - 1 + this.slides.length) % this.slides.length];
// 	this.nextSlide = this.slides[(this.selectedIndex + 1 + this.slides.length) % this.slides.length];
// 	// add classes
// 	changeSlideClasses(this.previousSlide, 'add', 'is-prev');
// 	changeSlideClasses(this.nextSlide, 'add', 'is-next');
// };

// function changeSlideClasses(slide, method, className) {
// 	if (!slide) {
// 		return;
// 	}
// 	slide.getCellElements().forEach(function(cellElem) {
// 		cellElem.classList[method](className);
// 	});
// }

$(window)
  .on("resize", function () {
    if ($(this).width() > 1700) {
      if (window.device == "mobile" || window.device == "laptop") {
        location.reload();
      }
      window.device = "desktop";
    } else if ($(this).width() > 1200) {
      if (window.device == "mobile" || window.device == "desktop") {
        location.reload();
      }
      window.device = "laptop";
    } else {
      if (window.device == "desktop" || window.device == "laptop") {
        location.reload();
      }
      window.device = "mobile";
    }
  })
  .trigger("resize");

$.fn.ryderCool = function (option) {
  return this.each(function () {
    var $this = $(this);

    var deFault = {
      hook: 0.9,
      repeat: false,
      enter_check: true,
      leave_check: true,
      count: 0,
      enter() {},
      leave() {},
    };

    var setting = $.extend(deFault, option);

    function ryderScrolling() {
      var scrollTop = $(window).scrollTop(),
        elementOffset = $this.offset().top,
        distance = elementOffset - scrollTop,
        windowHeight = $(window).height(),
        breakPoint = windowHeight * setting.hook,
        leavePoint = $this.height() - windowHeight * (1 - setting.hook);

      if (distance > breakPoint || distance < -leavePoint) {
        if (setting.count >= 1) {
          setting.enter_check = setting.repeat;
        }

        setting.leave_check && setting.leave($this);
        setting.leave_check = false;
      } else if (distance < breakPoint) {
        setting.enter_check && setting.enter($this);
        setting.enter_check && setting.count++;
        setting.enter_check = false;
        setting.leave_check = true;
      }
    }

    $(window).on("scroll", ryderScrolling).trigger("scroll");
  });
};

class RyderMarquee {
  constructor(el, direct = 0) {
    this.hero = $(el).parent().get(0);
    this.wrapper = el;
    this.delta = 0;
    this.transform = 0;
    this.step = device == "mobile" ? 0.4 : 0.8;
    this.direct = direct % 2;
    this.hover = false;

    if (this.direct == 1) {
      this.wrapper.style.transform = `translate3d(-${
        this.wrapper.getBoundingClientRect().width / 2
      }px, 0, 0)`;
      this.transform = -this.wrapper.getBoundingClientRect().width / 2;
    }

    // if (device != 'mobile') {
    // 	$(el).hover(() => {
    // 		this.hover = true
    // 	}, () => {
    // 		this.hover = false
    // 	})
    // }
  }

  animate() {
    if (!this.hover) {
      this.transform += this.step;
    }

    if (this.direct == 1) {
      if (this.transform > 0) {
        this.transform = -this.wrapper.getBoundingClientRect().width / 2;
      }
      this.wrapper.style.transform = `translate3d(${this.transform}px, 0, 0)`;
    } else {
      if (this.transform > this.wrapper.getBoundingClientRect().width / 2) {
        this.transform = 0;
      }
      this.wrapper.style.transform = `translate3d(-${this.transform}px, 0, 0)`;
    }
  }

  render() {
    this.scrollY = $(window).scrollTop();

    const bounding = this.hero.getBoundingClientRect();
    const distance =
      window.innerHeight + this.scrollY - (bounding.top + this.scrollY);
    const percentage =
      distance / ((window.innerHeight + bounding.height) / 100);

    this.animate();
  }

  create() {
    gsap.ticker.add(this.render.bind(this));
  }
}

$(".marquee").each(function (i, el) {
  var $copy = $(el).contents().clone();
  $(el).append($copy);

  var ryderMarquee = new RyderMarquee(el, i).create();
});

function ryderenter() {
  $("[data-r]").each(function (i, el) {
    if (device == "mobile" && $(el).data("mobile-r") != undefined) {
      var _p = $(el).data("mobile-r");
    } else {
      var _p = $(el).data("r");
    }

    var _st_default = {
      trigger: el,
      start: "top 80%",
      end: "bottom 0%",
      toggleActions: "play none play none",
      // toggleActions: "play reverse play reverse",
      // markers: true,
    };

    var _st = Object.assign(_st_default, _p.scrollTrigger);

    var _t = $(el).offset().top;
    var _hook = ($(window).height() * _st.start.replace(/[^0-9]/g, "")) / 100;

    if (_t <= _hook) {
      _p.delay = _p.delay != undefined ? (_p.delay += 1.5) : 1.5;
    }

    delete _p.scrollTrigger;

    var _setting = {
      scrollTrigger: _st,
      duration: 2,
      opacity: 0,
      ease: "power2.out",
    };

    if (_p != "" && "stagger" in _p) {
      var $el = $(el).children();
    } else {
      var $el = el;
    }

    var _obj = Object.assign(_setting, _p);

    gsap.from($el, _obj);
  });
}

var _scrollLast = 0;
$(window).on("scroll", () => {
  var _scrollTop = $(window).scrollTop();
  var _allBottom = $("body").height() - $(window).height() - 100;

  if (_scrollTop < 0 || _scrollTop > _allBottom) {
    return false;
  }

  if (_scrollTop > _scrollLast) {
    $("#topmenuWrap").addClass("is-hide");
  } else {
    $("#topmenuWrap").removeClass("is-hide");
  }

  _scrollLast = _scrollTop;
});

$(function () {
  ryderenter();
});

// window.onload = function () {
//   $("#preload").fadeOut(300);
// };

// shopline內容

$(".header__logo.header__logo--home").remove();

document.addEventListener("DOMContentLoaded", function () {
  function updateReviewCounts() {
    const reviewCounts = document.querySelectorAll(
      ".product-review-total-counts"
    );

    reviewCounts.forEach(function (el) {
      // 取出文字內容 (例如 "(1)")
      let rawText = el.textContent.trim();

      // 去掉括號，只留下數字
      let count = rawText.replace(/[()]/g, "");

      // 檢查是否為數字
      if (!isNaN(count) && count !== "") {
        // 單複數處理
        let label = count === "1" ? "Review" : "Reviews";

        // 更新文字
        el.textContent = `${count} ${label}`;
      }
    });
  }

  // 初次執行
  updateReviewCounts();

  // 使用 MutationObserver 監聽非同步變動（解決有時候失敗的問題）
  const observer = new MutationObserver(updateReviewCounts);
  observer.observe(document.body, { childList: true, subtree: true });
});
$("[data-share]").each((i, el) => {
  var type = el.dataset.share;
  $(el).click(function (e) {
    e.preventDefault();

    var winHeight = 360;
    var winWidth = 600;
    var winTop = screen.height / 2 - winHeight / 2;
    var winLeft = screen.width / 2 - winWidth / 2;
    var url = $(this).attr("href");

    if (type == "facebook") {
      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "twitter") {
      window.open(
        "https://twitter.com/share?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "pinterest") {
      window.open(
        "https://www.pinterest.com/pin/create/button/?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "googleplus") {
      window.open(
        "https://plus.google.com/share?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "linkedin") {
      window.open(
        "https://www.linkedin.com/cws/share?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "weibo") {
      window.open(
        "https://service.weibo.com/share/share.php?url=" + url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else if (type == "line") {
      window.open("https://line.naver.jp/R/msg/text/?" + url);
    } else if (type == "instagram") {
      window.open("https://www.instagram.com/?url=" + url);
    }
  });
});
$("#preload").delay(500).fadeOut(600);


if (location.href == "https://www.kussenbio.com/pages/qa" || location.href == "https://www.kussenbio.com/pages/product-features" || location.href == "https://www.kussenbio.com/pages/product-issues" || location.href == "https://www.kussenbio.com/pages/member-issues" || location.href == "https://www.kussenbio.com/pages/purchase-issues") {
    //安全與保存
    $(".accordion__17570588139540af109e__container h3").remove();
    $(".accordion__17570588139540af109e__container").prepend(`
           <div class="title-area">
				<div class="en">FEATURES</div>
				<div class="ch">安全與保存</div>
			</div>
     	 `);

    //產品使用指南
    $(".accordion__1757058965572392f9cc__container h3").remove();
    $(".accordion__1757058965572392f9cc__container").prepend(`
           <div class="title-area">
				<div class="en">PRODUCT</div>
				<div class="ch">產品使用指南</div>
			</div>
     	 `);

    //會員問題
    $(".accordion__17570589858450079689__container h3").remove();
    $(".accordion__17570589858450079689__container").prepend(`
           <div class="title-area">
				<div class="en">MEMBERSHIP</div>
				<div class="ch">會員問題</div>
			</div>
     	 `);

    //選購問題
    $(".accordion__1757059026375edcd50b__container h3").remove();
    $(".accordion__1757059026375edcd50b__container").prepend(`
           <div class="title-area">
				<div class="en">PURCHASE</div>
				<div class="ch">選購問題</div>
			</div>
     	 `);

    $(".accordion-item__icon.accordion-item__icon-plus").html(`
		<svg id="b" data-name="圖層 2" xmlns="http://www.w3.org/2000/svg" width="25.19" height="25.19" viewBox="0 0 25.19 25.19">
			<g id="c" data-name="圖層 2">
				<g>
				<rect class="d" x="12.18" width=".83" height="25.19"/>
				<rect class="d" y="12.18" width="25.19" height=".83"/>
				</g>
			</g>
		</svg>
	`);

    $(".accordion-item").prepend(`
		<div class="item-icon">
			<svg id="b" data-name="圖層 2" xmlns="http://www.w3.org/2000/svg" width="41.02"
				height="32.84" viewBox="0 0 41.02 32.84">
				<g id="c" data-name="圖層 2">
					<g>
						<path class="e"
							d="M37.82,24.81c1.78,0,3.19,1.41,3.19,3.19s-1.41,3.19-3.19,3.19-3.19-1.41-3.19-3.19,1.41-3.19,3.19-3.19Z" />
						<path class="e"
							d="M5.96,3.74C-1.02,9.49-2.01,19.9,3.74,26.88c5.75,6.97,16.17,7.97,23.14,2.22,6.97-5.75,7.97-16.17,2.22-23.14C23.35-1.02,12.93-2.01,5.96,3.74Z" />
						<path class="d"
							d="M23.09,21.59c1.43,0,2.82-.39,4.04-1.15l-.48-.75c-1.96,1.24-4.37,1.36-6.61.34-2.34-1.07-3.95-3.15-4.32-5.58l-.88.13c.41,2.73,2.22,5.06,4.84,6.26,1.11.51,2.27.75,3.42.75Z" />
						<path class="d"
							d="M24.96,8.66c0-2.33,1.9-4.23,4.23-4.23s4.23,1.9,4.23,4.23c0,2.33-1.9,4.23-4.23,4.23s-4.23-1.9-4.23-4.23ZM25.85,8.66c0,1.84,1.5,3.34,3.34,3.34s3.34-1.5,3.34-3.34c0-1.84-1.5-3.34-3.34-3.34s-3.34,1.5-3.34,3.34Z" />
						<path class="d"
							d="M14.71,8.66c0-2.33,1.9-4.23,4.23-4.23s4.23,1.9,4.23,4.23c0,2.33-1.9,4.23-4.23,4.23s-4.23-1.9-4.23-4.23ZM15.61,8.66c0,1.84,1.5,3.34,3.34,3.34s3.34-1.5,3.34-3.34-1.5-3.34-3.34-3.34-3.34,1.5-3.34,3.34Z" />
						<rect class="d" x="22.73" y="8.22" width="2.67" height=".89" />
						<rect class="d" x="10.61" y="3.54" width=".89" height="8.42"
							transform="translate(1.08 16.85) rotate(-77.43)" />
					</g>
				</g>
			</svg>
		</div>
	`);
  }

  gsap.delayedCall(0.5, function () {

    if ($(window).width() < 481) {
      // 原生寫法（不依賴 jQuery）
      const sosList = document.querySelector(".sosList");
      if (sosList && window.Flickity) {
        new Flickity(sosList, {
          prevNextButtons: false,
          pageDots: true,
          wrapAround: true,
          autoPlay: true,
          cellAlign: "center",
          imagesLoaded: true,
          pauseAutoPlayOnHover: false,
          arrowShape: "",
          fade: false,
        });
      }
    }

    if (
      location.href.includes("https://www.kussenbio.com/blog/posts") || 
      location.href.includes("https://www.kussenbio.com/blog/categories/")
    ) {
      $(".container.global-primary.ng-isolate-scope").prepend(`
        <div class="sos-banner">
            <img src="https://gdlinode.tw/kussen/images/sos-banner.png" alt="" class="sm:hidden">
            <img src="https://gdlinode.tw/kussen/images/sos-banner-mobile.png" alt="" class="hidden sm:block">
        </div>
	`);

      $(".post-categories-pannel__block-title").remove();
      $(".post-categories-pannel__block-list .count").remove();

      $(".post-categories-pannel__block-list").prepend(`
       <a href="https://www.kussenbio.com/blog/posts">
          ALL
        </a>
	`);

      $(".List-item-preview").remove();
      $(".primary-border-color-after").remove();

      $(".List-item-content").append(`
       <div class="more">
            <img src="https://gdlinode.tw/kussen/images/skin-more.svg" alt="">
        </div>
	`);

    $(".pagination").addClass("is-blog");
    }
  });

window.onload = function () {
  
  var a = document.querySelector(
    'a[link-highlight="https://www.kussenbio.com/pages/購買資訊"]'
  );
  if (a) {
    a.setAttribute("href", "javascript:;");
  }
  var b = document.querySelector(
    'a[href="https://www.kussenbio.com/pages/skin-sos"]'
  );
  if (b) {
    b.setAttribute(
      "href",
      "https://www.kussenbio.com/blog/posts"
    );
  }

  $("#shopline-section-176456344200813b87bf, #shopline-section-17645634116903b3458d").prepend(`
    <div class="title-area">
      <div class="en">SKIN S.O.S</div>
    </div>
  `);
  $("#shopline-section-176456344200813b87bf .owl-item, #shopline-section-17645634116903b3458d .owl-item").each(function (i, el) {
    const _url = $("a", el).attr("href");
    if (!_url) return; // 沒有網址就略過
  
    $(el).find(".post-item").append(`
      <div class="more">
        <a href="${_url}" target="_blank">
          <div class="text">Read</div>
          <div class="arrow">
            <img src="https://gdlinode.tw/kussen/images/more-arrow.svg" alt="">
          </div>
        </a>
      </div>
    `);
  });
  

  if (
    location.href == "https://www.kussenbio.com/pages/trial"
  ) {
    $(".product-text-custom-padding__17571629008351f64a96, .product-text-custom-padding__17769131752312b4108f, .product-text-custom-padding__1776927631187719179c").prepend(`
		<div class="title-area">
			<div class="en">IN-USE RESULTS</div>
            <div class="ch">試用體驗</div>
		</div>							
	`);
    $(".product-text-custom-padding__17769131752312b4108f .title-area, .product-text-custom-padding__1776927631187719179c .title-area").addClass("opacity-0");

    $(".text-block__button").text("");
    $(".text-block__button").html(`
		<div class="text">加入購物車</div>
		<div class="arrow"><img src="https://gdlinode.tw/kussen/images/more-arrow.svg"
		alt=""></div>
	`);
  } else if (location.href == "https://www.kussenbio.com/products" || location.href == "https://www.kussenbio.com/products/") {
    // ||
    // location.href.startsWith(
    //   "https://www.kussenbio.com/categories/"
    // )
    $(".ProductList-container").prepend(`
        <div class="product-bannerWrap">
              <ul class="product-bannerList">
                  <li style="background: url('https://gdlinode.tw/kussen/images/product-banner.jpg') center center / cover"></li>
                  <li style="background: url('https://gdlinode.tw/kussen/images/product-banner.jpg') center center / cover"></li>
                  <li style="background: url('https://gdlinode.tw/kussen/images/product-banner.jpg') center center / cover"></li>
              </ul>
          </div> 
    `);

    const container = document.querySelector(".ProductList-container");
    if (!container) return; // 容器不存在就直接離開（避免報錯）

    if (!container.querySelector(".product-bannerWrap")) {
      container.insertAdjacentHTML(
        "afterbegin",
        `
      <div class="product-bannerWrap">
        <ul class="product-bannerList">
          <li style="background: url('https://gdlinode.tw/kussen/images/product-banner.jpg') center center / cover"></li>
          <li style="background: url('https://gdlinode.tw/kussen/images/product-banner.jpg') center center / cover"></li>
          <li style="background: url('https://gdlinode.tw/kussen/images/product-banner.jpg') center center / cover"></li>
        </ul>
      </div>
    `
      );
    }

    // 2) 動態載入 CSS / JS
    function loadCSS(href) {
      return new Promise((res, rej) => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        link.onload = res;
        link.onerror = rej;
        document.head.appendChild(link);
      });
    }

    function loadJS(src) {
      return new Promise((res, rej) => {
        const s = document.createElement("script");
        s.src = src;
        s.async = true;
        s.onload = res;
        s.onerror = rej;
        document.head.appendChild(s);
      });
    }

    // 3) 等待 Flickity 可用後再初始化
    async function ensureFlickityAndInit() {
      // 若已存在，跳過載入
      const hasFlickity =
        !!window.Flickity || (window.jQuery && jQuery.fn && jQuery.fn.flickity);

      if (!hasFlickity) {
        // 取得核心 CSS + JS（含 imagesLoaded）
        await loadCSS(
          "https://cdnjs.cloudflare.com/ajax/libs/flickity/2.3.0/flickity.min.css"
        );
        await loadJS(
          "https://cdnjs.cloudflare.com/ajax/libs/flickity/2.3.0/flickity.pkgd.min.js"
        );
        // 取得 fade 外掛
        await loadJS("https://unpkg.com/flickity-fade@1/flickity-fade.js");
      }

      // 4) 初始化（jQuery 寫法 or 原生寫法擇一）

      // jQuery 寫法（頁面已有 jQuery 才用）
      if (window.jQuery && jQuery.fn && jQuery.fn.flickity) {
        jQuery(".product-bannerList").flickity({
          prevNextButtons: false,
          pageDots: true,
          wrapAround: true,
          autoPlay: true,
          cellAlign: "left",
          imagesLoaded: true,
          pauseAutoPlayOnHover: false,
          arrowShape: "",
          fade: true,
        });
        return;
      }

      // 原生寫法（不依賴 jQuery）
      const list = document.querySelector(".product-bannerList");
      if (list && window.Flickity) {
        new Flickity(list, {
          prevNextButtons: false,
          pageDots: true,
          wrapAround: true,
          autoPlay: true,
          cellAlign: "left",
          imagesLoaded: true,
          pauseAutoPlayOnHover: false,
          arrowShape: "",
          fade: true,
        });
      } else {
        console.warn("Flickity 未載入或找不到 .product-bannerList");
      }
    }

    ensureFlickityAndInit();

    $(".ProductList-info h1.Label").prepend(`
        <div class="en">
             PRODUCTS
          </div> 
    `);
  } else if (
    location.href.startsWith(
      "https://www.kussenbio.com/blog/posts/"
    )
  ) {
    //   $('.block-inner').prepend(`
    // {% assign hero_src = article.image | default: article.featured_image | default: article.og_image %}

    //   {% if hero_src %}
    //   <div class="sl-blog-social-hero">
    //     <img src="{{ hero_src }}" alt="{{ article.title }}" loading="lazy">
    //   </div>
    //   {% endif %}
    //   `)
    $("#Content").css("background-color", "#FFFCF8");
    $(".block-inner").addClass("blog-detail");

    //     $('.Post-date').prepend(`

    // `)

    //嵌入分類
    var catLink = document.querySelector(
      '.block-inner.blog-detail a[href*="/blog/categories/"]'
    );
    if (catLink) {
      var category = catLink.textContent.trim();
      // 找到 post-date 元素
      var dateEl = document.querySelector(".Post-date");
      if (dateEl) {
        // 直接覆蓋掉原本的日期
        dateEl.textContent = category;
      }
    }
    $(".post-info-section__left").append(`
       <div class="socialListWrap">
            <div class="title">SHARE</div>
            <ul class="socialList">
                <li>
                    <a href="javascript:;" data-share="facebook"><img src="https://gdlinode.tw/kussen/images/b-fb.svg" alt=""></a>
                </li>
                <li>
                    <a href="javascript:;" data-share="line"><img src="https://gdlinode.tw/kussen/images/b-line.svg" alt=""></a>
                </li>
            </ul>
        </div>
      `);

    //嵌入封面圖

    if (!/\/blogs\//.test(location.pathname)) {
      // 1. 抓 og:image
      var ogImg = document.querySelector('meta[property="og:image"]');
      var src = ogImg && ogImg.getAttribute("content");

      console.log(src);

      if (!src) return;

      // 2. 找到 .post-content
      var content = document.querySelector(".Post-content");
      if (!content) return;

      // 3. 建立圖片元素
      var img = document.createElement("img");
      img.src = src;
      img.alt = document.title || "";
      img.className = "sl-blog-hero";
      img.loading = "lazy";

      // 4. prepend 到最前面
      content.insertBefore(img, content.firstChild);
    }

    //嵌入敘述

    const post = document.querySelector(".Post");

    // 找到 .Post-date 和 .Post-content
    const postDate = post.querySelector(".Post-date");
    const postContent = post.querySelector(".Post-content");

    // 建立新的 div
    const descDiv = document.createElement("div");
    descDiv.className = "Post-description";
    descDiv.textContent = "這是 description 的內容";

    // 插入在 Post-date 後面 (也就是 Post-content 前面)
    post.insertBefore(descDiv, postContent);

    var description = $('meta[name="description"]').attr("content");
    $(".Post-description").text(description);
  }
  // ===================
};
